/**
 * Centralized configuration from environment variables.
 * All values use VUE_APP_ prefix (required by Vue CLI for client exposure).
 * Fallbacks ensure the app works when .env is missing or incomplete.
 *
 * SECURITY: Do not put secrets here that must stay server-side only.
 * VUE_APP_* vars are embedded in the client bundle at build time.
 */

function env(key, fallback) {
  const v = process.env[key];
  return (v !== undefined && v !== null && String(v).trim() !== '') ? String(v).trim() : fallback;
}

/** Backend root URL (no trailing slash), e.g. https://bildungsangebote-kiel.de */
const baseUrl = env('VUE_APP_BASE_URL', 'https://bildungsangebote-kiel.de').replace(/\/+$/, '');

/**
 * Full API base URL with trailing slash.
 * Resolution priority (for backwards compatibility):
 * 1. VUE_APP_API_BASE_URL (preferred, matches other apps like docker-kkk/docker-jobfl)
 * 2. VUE_APP_BASE_API (legacy name used by the original NZAPP implementation)
 * 3. baseUrl + /api/
 */
const apiBaseUrlRaw =
  env('VUE_APP_API_BASE_URL', '') ||
  env('VUE_APP_BASE_API', '') ||
  `${baseUrl}/api/`;

const apiBaseUrl = apiBaseUrlRaw.replace(/\/+$/, '') + '/';

export default {
  /** Backend root for asset URLs (logos, etc.) */
  baseUrl,

  /** API base URL for axios requests */
  apiBaseUrl,

  /** App and content configuration from ContentHub backend */
  appId: env('VUE_APP_APP_ID', '2'),
  appName: env('VUE_APP_APP_NAME', 'Kiel.RefugeeCompass'),
  institutionId: env('VUE_APP_INSTITUTION_CONTENT_TYPE_ID', '1'),
  offerId: env('VUE_APP_OFFER_CONTENT_TYPE_ID', '2'),
  defaultCity: env('VUE_APP_DEFAULT_CITY', 'Kiel'),

  /** CMS content IDs */
  impressumContentId: env('VUE_APP_IMPRESSUM_CONTENT_ID', '10291'),
  datenschutzContentId: env('VUE_APP_DATENSCHUTZ_CONTENT_ID', '10281'),
  barrierefreiheitContentId: env('VUE_APP_BARRIEREFREIHEIT_CONTENT_ID', '244129'),

  /** UI configuration */
  shortDescriptionWordCount: parseInt(env('VUE_APP_SHORT_DESCRIPTION_WORD_COUNT', '215'), 10) || 215,

  /** API key for X-Api-Key header (required when backend enforces) */
  apiKey: env('VUE_APP_API_KEY', ''),
};

